import React from 'react'
import Radio from '@mui/material/Radio'

const AdxRadioButton = ({ type, sx, ...rest }) => {
  // props
  // 1. type: string
  // accepted value: 'fill', 'no-fill', 'no-radio'

  const disabledStyle = () => {
    return {
      color: 'gray-line.main',
      backgroundColor: 'transparent',
      p: '9px',
      height: '45px',
      width: '42px',
    }
  }

  switch (type) {
    case 'no-radio':
      return (
        <Radio
          disableRipple
          color="primary"
          sx={{
            height: '45px',
            width: '42px',
            display: 'none',
            '&.Mui-disabled': disabledStyle(),
            ...sx,
          }}
          {...rest}
        />
      )

    default:
      return (
        <Radio
          disableRipple
          color="primary"
          sx={{
            height: '45px',
            width: '42px',
            display: 'flex',
            alignItems: 'flex-start',
            '&.Mui-disabled': disabledStyle(),
            ...sx,
          }}
          {...rest}
        />
      )
  }
}

export default AdxRadioButton
